import { getTranslations } from "../../i18n"
import { useLocale } from "../../locale-context"

export function JournalError({ onRetry }: { onRetry: () => void }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	return (
		<div className="text-center py-8">
			<div className="text-destructive font-medium">{t.journal.errorTitle}</div>
			<button
				type="button"
				onClick={onRetry}
				className="mt-2 underline text-sm"
			>
				{t.journal.errorRetry}
			</button>
		</div>
	)
}
